import { Box } from "@mui/material";
import React from "react";
import Title from "../../components/title";
import './contact.scss';
import img from '../../images/contact.gif'
import { useForm, ValidationError } from "@formspree/react";

const Contact = () => {

    const [state, handleSubmit] = useForm("xayvqopv");
    if (state.succeeded) {
      return <Box><h3 className='text-white text-center mt-10'>Thanks for your acknowledgement! 😃✨</h3></Box>;
    }

  return (
    <Box sx={{ mt: 5, display: { md: "flex" } }} className="items-center">
      <Box sx={{ width: { md: "50%" } }}>
        <Title title="Contact" />
        <form className="mt-10" onSubmit={handleSubmit}>
          <input
            className="input"
            placeholder="Your Name"
            type="text"
            id="name"
            name="name"
            required
          />
          <ValidationError prefix="Name" field="name" errors={state.errors} />
          <input
            className="input"
            placeholder="Your Email"
            type="email"
            id="email"
            name="email"
            required
          />
          <ValidationError prefix="Email" field="email" errors={state.errors} />
          <textarea
            className="input"
            placeholder="Your Thought"
            type="text"
            id="msg"
            name="msg"
            rows="5"
            required
          />
          <ValidationError prefix="Message" field="msg" errors={state.errors} />

          <button className='primary-btn mt-5 px-6 py-2 font-semibold rounded-full' type="submit" disabled={state.submitting}>
            Send
          </button>
        </form>
      </Box>
      <Box
        sx={{ mt: 5, display: { md: "flex" }, width: { md: "50%" } }}
        className="justify-center"
      >
        <img src={img} alt="" width="250px" />
      </Box>
    </Box>
  );
};

export default Contact;
